/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialSummaryRowDto
 */
export interface FinancialSummaryRowDto {
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    lossType: FinancialSummaryRowDtoLossTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    previousIncurredOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    previousIncurredOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    paymentsOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    paymentsOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    outstandingOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    outstandingOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    newIncurredOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryRowDto
     */
    newIncurredOurShare: string;
}


/**
 * @export
 */
export const FinancialSummaryRowDtoLossTypeEnum = {
    Indemnity: 'Indemnity',
    LossAdjusterCosts: 'Loss Adjuster Costs',
    ConsultantCosts: 'Consultant Costs',
    LegalCosts: 'Legal Costs',
    RiCosts: 'RI Costs'
} as const;
export type FinancialSummaryRowDtoLossTypeEnum = typeof FinancialSummaryRowDtoLossTypeEnum[keyof typeof FinancialSummaryRowDtoLossTypeEnum];


/**
 * Check if a given object implements the FinancialSummaryRowDto interface.
 */
export function instanceOfFinancialSummaryRowDto(value: object): value is FinancialSummaryRowDto {
    if (!('lossType' in value) || value['lossType'] === undefined) return false;
    if (!('previousIncurredOurLayer' in value) || value['previousIncurredOurLayer'] === undefined) return false;
    if (!('previousIncurredOurShare' in value) || value['previousIncurredOurShare'] === undefined) return false;
    if (!('paymentsOurLayer' in value) || value['paymentsOurLayer'] === undefined) return false;
    if (!('paymentsOurShare' in value) || value['paymentsOurShare'] === undefined) return false;
    if (!('outstandingOurLayer' in value) || value['outstandingOurLayer'] === undefined) return false;
    if (!('outstandingOurShare' in value) || value['outstandingOurShare'] === undefined) return false;
    if (!('newIncurredOurLayer' in value) || value['newIncurredOurLayer'] === undefined) return false;
    if (!('newIncurredOurShare' in value) || value['newIncurredOurShare'] === undefined) return false;
    return true;
}

export function FinancialSummaryRowDtoFromJSON(json: any): FinancialSummaryRowDto {
    return FinancialSummaryRowDtoFromJSONTyped(json, false);
}

export function FinancialSummaryRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialSummaryRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lossType': json['lossType'],
        'previousIncurredOurLayer': json['previousIncurredOurLayer'],
        'previousIncurredOurShare': json['previousIncurredOurShare'],
        'paymentsOurLayer': json['paymentsOurLayer'],
        'paymentsOurShare': json['paymentsOurShare'],
        'outstandingOurLayer': json['outstandingOurLayer'],
        'outstandingOurShare': json['outstandingOurShare'],
        'newIncurredOurLayer': json['newIncurredOurLayer'],
        'newIncurredOurShare': json['newIncurredOurShare'],
    };
}

export function FinancialSummaryRowDtoToJSON(json: any): FinancialSummaryRowDto {
    return FinancialSummaryRowDtoToJSONTyped(json, false);
}

export function FinancialSummaryRowDtoToJSONTyped(value?: FinancialSummaryRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lossType': value['lossType'],
        'previousIncurredOurLayer': value['previousIncurredOurLayer'],
        'previousIncurredOurShare': value['previousIncurredOurShare'],
        'paymentsOurLayer': value['paymentsOurLayer'],
        'paymentsOurShare': value['paymentsOurShare'],
        'outstandingOurLayer': value['outstandingOurLayer'],
        'outstandingOurShare': value['outstandingOurShare'],
        'newIncurredOurLayer': value['newIncurredOurLayer'],
        'newIncurredOurShare': value['newIncurredOurShare'],
    };
}

